import {
    CircularProgress,
    Grid,
    InputAdornment,
    TextField, Button,Box
  } from "@mui/material";
  import { Search, SentimentDissatisfied } from "@mui/icons-material";
  import React, { useEffect, useState } from "react";
  import { useSnackbar } from "notistack";
  import axios from "axios";
  import { ToggleButton} from "@mui/material";
  import { styled } from "@mui/material/styles";


const Genre = ({genres, setGenres})=>{
    
    const [genreItems, setGenreItems]=useState(
            [
                { name: "All Genre", isActive: true, value:"All" },
                { name: "Education", isActive: false , value:"Education"},
                { name: "Sports", isActive: false , value:"Sports"},
                { name: "Comedy", isActive: false, value:"Comedy" },
                {name: "Lifestyle", isActive: false, value:"Lifestyle"}
            ]
    );
    
    const ColorButton = styled(ToggleButton)({
      textTransform: "capitalize",
      color: "#ffffff",
      fontsize: "1.5rem",
      background: "none",
      border: "none",
      height: "2rem",
      borderRadius: "16px",
      boxShadow: "none",
      fontWeight: "400",
      "&.Mui-selected:hover": {
        backgroundColor: "#ededed",
        color: "#000000",
        borderRadius: "16px",
      },
      "&.Mui-selected": {
        backgroundColor: "#ffffff",
        color: "#000000",
        borderRadius: "16px",
      },
      "&:focus": {
        backgroundColor: "#ffffff",
        color: "#586069",
        borderRadius: "16px",
      },
    });

    const handler = async(e, index) =>{
      let selectedGenre = e.target.value;
      console.log("selctedgnre", selectedGenre);
      console.log("index", index);

      if (selectedGenre === "All") {
        setGenres(["All"]);
      } else {
        genres = genres.filter((item) => item !== "All");
        if (genres.includes(selectedGenre)) {
          genres = genres.filter((e) => e !== selectedGenre);
          setGenres(genres);
        } else {
          genres.push(selectedGenre);
          setGenres(genres);
        }
        if (genres.length === 0) {
          setGenres(["All"]);
        }
      }
      
    }
      return(

        <Grid container
        direction="row"
        justifyContent={{xs:"space-evenly",md:"center"}}
        alignItems="center"
        spacing={{xs:0,md:5}}marginLeft="1rem">
  
              {
                genreItems.map((el, index) =>{
  
                  return (
                    <Grid item mt={1}>
                    <ColorButton key={index}  variant="contained"
                    selected={genres.includes(el.value) ? true : false} value={el.value} onClick={async (e) => await handler(e,index)}>
                      {el.name}
                  </ColorButton>
                  </Grid>
                  );
                })}
  
            </Grid>

      )

}

    export default Genre;